import React from "react";

import BusinessUnitSection from "./BusinessUnitSection";
import OptionAddInput from "./OptionAddInput";

const EntityPanelBody = ({
  entity,
  buOptions = [],
  fnOptions = [],
  subFnOptions = [],
  onAddBu,
  onAddFunction,
  onAddSubFunction,
}) => {
  const existingBuNames = (entity.business_units || []).map((b) => b.business_unit);

  return (
    <>
      {(entity.business_units || []).map((bu, buIdx) => (
        <BusinessUnitSection
          key={`${bu.business_unit}-${buIdx}`}
          bu={bu}
          fnOptions={fnOptions}
          subFnOptions={subFnOptions}
          onAddFunction={(name) => onAddFunction(buIdx, name)}
          onAddSubFunction={(fnIdx, name) => onAddSubFunction(buIdx, fnIdx, name)}
        />
      ))}

      <OptionAddInput
        placeholder="Add business unit"
        existingValues={existingBuNames}
        options={buOptions}
        onAdd={onAddBu}
      />
    </>
  );
};

export default EntityPanelBody;
